<div class="relative">
  <!-- Label -->
  <label *ngIf="label" class="block text-[10px] font-semibold text-[var(--tertiary-text)] uppercase tracking-wide mb-1">{{ label }}</label>

  <!-- Trigger -->
  <div (click)="toggle()"
    class="w-full flex items-center justify-between py-2 px-2.5 border-[1.5px] rounded-lg text-xs font-medium bg-white transition-all"
    [ngClass]="{
      'border-[var(--primary-dark)] text-[var(--primary-dark)]': open,
      'border-[var(--app-border)] text-[var(--base-text-alt-dark)]': !open,
      'opacity-50 cursor-not-allowed': disabled,
      'cursor-pointer hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)]': !disabled
    }">
    <span class="flex items-center gap-1.5" [ngClass]="value != null ? 'text-black' : 'text-gray-400'">
      <img *ngIf="selectedIcon" [src]="selectedIcon" class="w-4 h-4" alt="">
      {{ value != null ? selectedLabel : placeholder }}
    </span>
    <span class="material-icons text-[16px] transition-transform" [ngClass]="{'rotate-180': open}">expand_more</span>
  </div>

  <!-- Dropdown panel -->
  <div *ngIf="open"
    class="absolute z-50 mt-1 w-full min-w-[180px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 max-h-[200px] overflow-y-auto">
    <!-- Search -->
    <div *ngIf="searchable" class="px-2.5 py-1.5 border-b border-[var(--app-border)]">
      <input type="text" [(ngModel)]="search" placeholder="Search..." (keydown.enter)="selectFirst()"
        class="ui-dropdown-search w-full px-2 py-1.5 text-xs text-black rounded-md border border-[var(--app-border)] outline-none focus:border-[var(--primary-dark)]" />
    </div>

    <!-- Options -->
    <div *ngFor="let option of filtered" (click)="select(option)"
      class="py-2 px-3 text-[12px] font-medium cursor-pointer transition-colors flex items-center gap-2 whitespace-nowrap"
      [ngClass]="option.id === value ? 'bg-[var(--app-base)] text-[var(--primary-dark)] font-semibold' : 'text-black hover:bg-[var(--app-base)]'">
      <img *ngIf="option.icon" [src]="option.icon" class="w-4 h-4" alt="">
      {{ option.name }}
    </div>

    <!-- No results -->
    <div *ngIf="filtered.length === 0" class="py-2 px-3 text-[12px] text-[var(--tertiary-text)]">No results</div>
  </div>
</div>
